import React, { useState } from 'react';
import {
  useFaqsQuery,
  useRemoveFaqMutation,
  useSaveFaqMutation,
} from '@/queries/faq';
import { useFestivalWorkspaceStore } from '@/stores/festival-workspace-store';
import { FestivalHeader, Loading } from '../controls';
import Portal from '../modal/Portal';
import FilterableTable from '../table';
import { FAQForm } from './FAQForm';

export function FAQS() {
  const festival = useFestivalWorkspaceStore((s) => s.festival);
  const festivalId = festival?.festivalId;

  const faqsQ = useFaqsQuery(festivalId);
  const saveMutation = useSaveFaqMutation(festivalId);
  const removeMutation = useRemoveFaqMutation(festivalId);

  const faqs = faqsQ.data ?? [];
  const loading = festivalId == null || faqsQ.isPending || faqsQ.isFetching;

  const [showModal, setShowModal] = useState(false);
  const [selectedFAQ, setSelectedFAQ] = useState({});

  const buildColumnDefinitions = () => {
    var columnDefs = {};
    columnDefs.faqName = {
      header: 'FAQ',
      filterable: true,
      sortable: true,
      showViewLink: false,
      handleClick: true,
    };
    return columnDefs;
  };

  const openModal = (faq) => {
    const next = faqs.find((f) => faq.faqId === f.faqId) || {};
    setSelectedFAQ(next);
    setShowModal(true);
  };

  const onFileUpload = (fileInfo) => {
    const { filename, url } = fileInfo;
    setSelectedFAQ((prev) => ({
      ...prev,
      photoURL: url,
      faqPhoto: filename,
    }));
  };

  const onFileDelete = () => {
    setSelectedFAQ((prev) => {
      const next = { ...prev };
      next.photoURL = null;
      next.faqPhoto = null;
      return next;
    });
  };

  const saveFAQ = async (values) => {
    const updatedFAQ = { ...selectedFAQ, ...values };
    try {
      await saveMutation.mutateAsync(updatedFAQ);
      setShowModal(false);
      setSelectedFAQ({});
    } catch {
      /* mutation toast */
    }
  };

  const removeFAQ = async () => {
    try {
      await removeMutation.mutateAsync(selectedFAQ.faqId);
      setShowModal(false);
      setSelectedFAQ({});
    } catch {
      /* mutation toast */
    }
  };

  return (
    <>
      <FestivalHeader
        title="FAQs"
        showExit={true}
        showAdd={true}
        addTitle="Add FAQ"
        addAction={() => {
          setSelectedFAQ({});
          setShowModal(true);
        }}
      />
      {loading ? (
        <Loading />
      ) : (
        <FilterableTable
          data={faqs}
          tableTitle=""
          columns={buildColumnDefinitions()}
          includeFilter={false}
          addNewRecordText="FAQ"
          editHandler={openModal}
          toggleModal={openModal}
        />
      )}

      <Portal
        header={
          selectedFAQ ? selectedFAQ.faqName || 'Add New FAQ' : 'Add New FAQ'
        }
        open={showModal}
        onClose={() => setShowModal(false)}
      >
        <FAQForm
          faq={selectedFAQ}
          handleSave={saveFAQ}
          loading={loading}
          handleRemove={removeFAQ}
          onFileDelete={onFileDelete}
          onFileUpload={onFileUpload}
        />
      </Portal>
    </>
  );
}
